import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./common/loader";
import { loginAsync, signUpAsync } from "../redux/thunk/user";
import { useDispatch, useSelector } from "react-redux";
import { loginSelector, selectUser } from "../redux/selectors/user.selector";

const Callback = () => {
  const [loginMessage, setLoginMessage] = useState(<Loader />);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const firstTimeRegistration = useSelector(
    (state) => state.ui.firstTimeRegistration
  );
  const redirectToPricing = useSelector((state) => state.ui.redirectToPricing);

  const userData = useSelector(selectUser);
  const isLoggedIn = useSelector(loginSelector);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("code")) {
      const code = urlParams.get("code");
      getAccessToken(code);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      if (redirectToPricing) {
        navigate("/pricing");
      } else {
        navigate("/account");
      }
    }
  }, [isLoggedIn, redirectToPricing]);

  function getAccessToken(code) {
    if (firstTimeRegistration) {
      dispatch(signUpAsync(code, userData.phoneNumber, userData.country));
    } else {
      dispatch(loginAsync(code));
    }
  }

  return <h1>{loginMessage}</h1>;
};

export default Callback;
